import React, { useEffect } from 'react';
import { MytaverseEventProvider } from '../modules/dashboard/providers';
import LoadingProgress from '../components/LoadingProgress';
import { useCheckUniqueApplicationAccessPerAccount } from '../hooks/permissions';
import { useInitPrivateRoutesState } from './hooks';
import VideoGamecast from '../components/VideoGameCast';
import { useMytaverse } from '../providers/MytaverseProvider';

const EventPageContainer: React.FC = () => {
  const hasMultipleConnections = useCheckUniqueApplicationAccessPerAccount();
  const initializing = useInitPrivateRoutesState();
  const { navigateToEventsPage } = useMytaverse();

  useEffect(() => {
    if (hasMultipleConnections) {
      navigateToEventsPage('notifications.duplicateGamecastSession');
    }
  }, [hasMultipleConnections, navigateToEventsPage]);

  if (initializing || hasMultipleConnections === null) {
    return <LoadingProgress height="100%" />;
  }

  if (hasMultipleConnections) {
    return null;
  }

  return (
    <>
      <MytaverseEventProvider />
      <VideoGamecast />
    </>
  );
};

export default EventPageContainer;
